import { MonkeyFetch } from "@timwheeler/monkey-fetch";
import { getMsalObjPromise } from "./getMsalObj";
import {
  InteractionRequiredAuthError,
  BrowserAuthError,
} from "@azure/msal-browser";

const ONEWAY_STATEMENTS_URL_PROD_PREFIX =
  process.env.ONEWAY_STATEMENTS_FLATGEOBUF_URL_PROD_PREFIX;
const ONEWAY_STATEMENTS_URL_DEV_PREFIX =
  process.env.ONEWAY_STATEMENTS_FLATGEOBUF_URL_DEV_PREFIX;
const HDLANERESTRICTION_STATEMENTS_URL_PROD_PREFIX =
  process.env.HDLANERESTRICTION_STATEMENTS_FLATGEOBUF_URL_PROD_PREFIX;
const SDLANERESTRICTION_STATEMENTS_URL_PROD_PREFIX =
  process.env.SDLANERESTRICTION_STATEMENTS_FLATGEOBUF_URL_PROD_PREFIX;
const GENESIS_CURVATURES_URL = process.env.GENESIS_CURVATURES_FLATGEOBUF_URL;
const GENESIS_GRADIENT_URL = process.env.GENESIS_GRADIENT_FLATGEOBUF_URL;
const ONEWAY_MODERATIONS_URL = process.env.ONEWAY_MODERATIONS_FLATGEOBUF_URL;
const LANERES_MODERATIONS_URL = process.env.LANERES_MODERATIONS_FLATGEOBUF_URL;
const DEM_GRADIENT_URL = process.env.DEM_GRADIENT_FLATGEOBUF_URL;
const SDLANERES_MODERATIONS_URL =
  process.env.SDLANERES_MODERATIONS_FLATGEOBUF_URL;
const BINDING_REPORTS_URL = process.env.BINDING_REPORTS_URL;
const MOMA_TRACES_URL = process.env.MOMA_TRACES_URL;

export function configureMonkeyFetch() {
  const monkeyFetch = new MonkeyFetch();

  monkeyFetch.configure({
    request: (resource, options) => {
      if (
        !resource.startsWith(ONEWAY_STATEMENTS_URL_PROD_PREFIX) &&
        !resource.startsWith(ONEWAY_STATEMENTS_URL_DEV_PREFIX) &&
        !resource.startsWith(HDLANERESTRICTION_STATEMENTS_URL_PROD_PREFIX) &&
        !resource.startsWith(SDLANERESTRICTION_STATEMENTS_URL_PROD_PREFIX) &&
        !resource.startsWith(GENESIS_CURVATURES_URL) &&
        !resource.startsWith(GENESIS_GRADIENT_URL) &&
        !resource.startsWith(ONEWAY_MODERATIONS_URL) &&
        !resource.startsWith(LANERES_MODERATIONS_URL) &&
        !resource.startsWith(SDLANERES_MODERATIONS_URL) &&
        !resource.startsWith(DEM_GRADIENT_URL) &&
        !resource.startsWith(BINDING_REPORTS_URL) &&
        !(MOMA_TRACES_URL && resource.startsWith(MOMA_TRACES_URL)) &&
        !resource.includes(".blob.core.windows.net")
      ) {
        return Promise.resolve([resource, options]);
      }
      // flatgeobuf 4 passes a Headers object; spreading it would drop Range.
      const newOptions = { ...options, headers: new Headers(options?.headers) };

      return getMsalObjPromise().then((msalObj) => {
        const account = msalObj.getAllAccounts()[0];
        const request = {
          account: account,
          scopes: ["https://storage.azure.com/user_impersonation"],
        };
        return msalObj
          .acquireTokenSilent(request)
          .then(function (tokenResponse) {
            if (resource.includes(".blob.core.windows.net")) {
              newOptions.headers.set(
                "Authorization",
                `Bearer ${tokenResponse.accessToken}`,
              );
              newOptions.headers.set("x-ms-version", "2020-04-08");
            } else {
              newOptions.headers.set(
                "Authorization",
                `Bearer ${tokenResponse.idToken}`,
              );
            }
            return Promise.resolve([resource, newOptions]);
          })
          .catch(function (error) {
            if (
              error instanceof InteractionRequiredAuthError ||
              error instanceof BrowserAuthError
            ) {
              return msalObj.acquireTokenRedirect(request);
            }
            return Promise.reject();
          });
      });
    },

    requestError: (error) => {
      return Promise.reject(error);
    },

    response: (response) => {
      // check if response is a 401, if so
      // reject and invoke response error handler
      if (response.status === 401) {
        return Promise.reject(response);
      }
      return Promise.resolve(response);
    },

    responseError: async (response) => {
      // add custom response error handling
      return Promise.reject(response);
    },
  });
}
